var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarnning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1064",
    "data-name": "Group 1064",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.067,
    height: 66.97,
    viewBox: "0 0 71.067 66.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M69.591,66l-25.1-46.149a10.411,10.411,0,0,0-17.9,0L1.478,66a10.405,10.405,0,0,0,8.95,15.725h50.21A10.407,10.407,0,0,0,69.591,66ZM35.534,73.4A4.164,4.164,0,1,1,39.7,69.237,4.17,4.17,0,0,1,35.534,73.4ZM39.7,56.744a4.164,4.164,0,1,1-8.328,0V35.924a4.164,4.164,0,0,1,8.328,0Z",
    transform: "translate(0 -14.759)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnning);
export default __webpack_public_path__ + "static/media/warnning.84bb204139cfc2af7a1a1870207537a2.svg";
export { ForwardRef as ReactComponent };